<template>
  <ui-toast :toast="toast" @action="ctl.runToastAction()" />
</template>

<script>
/** Kratko obavještenje na dnu (sa "Vrati" poslije snimanja). */
export default {
  name: "SetToast",
  inject: { ctl: "settingsCtl" },
  computed: {
    toast() {
      return this.ctl.ui.toast;
    },
  },
};
</script>
